enum OccupationAreaEnum {
  NURSING = 'Enfermagem',
  MEDICINE = 'Medicina',
}

export default OccupationAreaEnum;
